export default "__VITE_ASSET__Bvv9AH7Q__";